export default {
    setItem(key, value) {
        localStorage.setItem(key, value)
    },
    getItem(key) {
        return localStorage.getItem(key);
    },
    setUser(user) {
        localStorage.setItem('authUser', JSON.stringify(user));
    },
    getUser() {
        return JSON.parse(localStorage.getItem('authUser'));
    }
}